CreditCardFormError = require '../../internal/credit-card-form-error'
Promise = require 'bluebird'
React = require 'react'
_ = require 'underscore'
f = require 'effing'
t = require 'recup'
xtend = require 'xtend'

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @state = @props.initialState

  getData: ->
    for field, validator of @props.requiredFields ? {}
      value = @state[field]
      valid =
        if _.isRegExp(validator)
          validator.test(value)
        else if _.isFunction(validator)
          validator(value, @state)
        else
          _.isEqual(validator, value)

      if !valid
        return Promise.reject CreditCardFormError.InvalidField('', { field })

    Promise.resolve(@props.getAsyncData?())
    .then (asyncData) =>
      if @props.formFields
        xtend asyncData, _.object @props.formFields.map (field) =>
          [field, @state[field]]

  controlledOpts: (key) ->
    onChange: (e) =>
      update = {}
      update[key] = e.target.value
      @setState update
    value: @state[key]

  render: t.renderable ->
    @props.render({
      controlledOpts: f(@, 'controlledOpts')
      form: @
      formState: @state
      getData: f(@, 'getData')
      setFormState: f(@, 'setState')
    })
